<template>
  <div class="checkservice">
    <!--项目详情-->
    <div class="order__itemBox">
      <div class="storeList flex_center radius5" >
        <div class="storeList__img itemList__img"><img :src="order.service_thumb" alt=""></div>
        <div class="storeList__content">
          <div>{{order.servicetitle}}</div>
          <div class="col_999 fs_12 mb_5 one">{{order.service_desc}}</div>
          <div class="itemList_price fs_12"><span>¥{{order.service_price}}起</span>{{order.servicetime}}分钟/次</div>
        </div>
      </div>
    </div>

    <div class="service_box">

      <div class="service_store">
        <span class="iconfont icon-dianpu"></span>
        <span>{{store.storename}}</span>
      </div>

      <div class="service_address">
        <span class="iconfont icon-dingwei-xianxing"></span>
        <span>{{store.address}}</span>
      </div>

      <div class="service_qrcode">
        <img :src="order.verify_qrcode" alt="">
        <!-- <p>有效期至: 2019-09-21</p> -->
      </div>

      <div class="service_tip">
        <p>使用规则:</p>
        <p>请手持二维码至线下门店，出示该二维码进行扫描</p>
      </div>

      <backButton></backButton>

    </div>

  </div>
</template>

<script>
import backButton from '@/components/backButton.vue';

export default {
  name: "checkservice",
  components: { backButton },
  data() {
    return {
      orderid:0,
      order:[],
      store:[]
    }
  },
  created() {
    this.orderid = this.$route.query.orderid;
    this.init();
  },
  methods: {
    init(){
      this.order_detail();
    },
    order_detail(){ 
      if(this.orderid != 0){
        this.axios({
          url: this.api.order.order_detail, 
          data: { order_id: this.orderid }
        }).then(res => {
          if (res.error === 0) {
            this.order = res.data.order;
            this.store = res.data.store;
          }
        });
      }else{

      }
    },
    back(){
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
  @import '../../assets/css/store.css';   /*门店样式*/
  @import '../../assets/css/item.css';   /*服务项目*/
  .order__itemBox{
    background: #45B9BC;
    padding: .75rem .5rem;
  }
  .storeList{
    margin-bottom: 0;
  }

.icon-dianpu{
  color:#969191;
}
.service_box{
  background-color:white;
  margin-top:.5rem;
  padding:.5rem .75rem;
  font-size:.7rem;
  color:#8A8B8B;
}
.service_address{
  padding:.25rem 0;
}
.service_qrcode{
  margin:1.5rem auto;
  width:58%;
  text-align:center;
}
.service_tip p:first-child{
  font-size:.7rem;
  color:#424242;
}
.service_tip p:last-child{
  font-size:.7rem;
  color:#8A8B8B;
  padding:.25rem 0;
}

</style>



// WEBPACK FOOTER //
// src/views/order/checkservice.vue